// extracted by css-extract-rspack-plugin
export default {"pulse":"pulse-RGHFhu"};